module.exports = __webpack_public_path__ + "img/img16.b4b540d1.png";